import React from "react";
import LoadingOverlay from '@ronchalant/react-loading-overlay';

const OverLay = ({ overlay }) => {
  return (
    <LoadingOverlay className="mf-font lazy-loading" active={overlay} spinner text='Please wait...'  
      styles={{ 
        spinner: (base) => ({
          ...base,
          width: '150px',
          '& svg circle': {
            stroke: '#003c70'
          }
        }),
        overlay: (base) => ({
          ...base,
          background: '#F1F5F6',
          opacity: '0.8',
          fontWeight: 'bold',
          color: '#202336',
          position: 'absolute'
         })
      }}> 
      </LoadingOverlay> 
  );
};

export default OverLay;